// extracted by mini-css-extract-plugin
module.exports = {"tactics":"tactics_tactics___6NLw","subheadline":"tactics_subheadline__eocsi","cards":"tactics_cards___zCLc","card":"tactics_card__F6jyW"};